import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-cheque-ordem-ocorrencias',
  templateUrl: './consulta-cheque-ordem-ocorrencias.component.html',
  styleUrls: ['./consulta-cheque-ordem-ocorrencias.component.scss']
})
export class ConsultaChequeOrdemOcorrenciasComponent implements OnInit {

  title = "Cheque - Contra Ordem - Outras Ocorrências";
  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    if(this.codigoControle == "SEMREGISTRO_OK") {
      this.status = 'success';
    }
  }

}
